<script lang="ts" setup>
import { ref, useTemplateRef } from "vue";
import OmniDialog from "@/components/omni/OmniDialog.vue";
import PickupInfoForm from "@/views/trips/components/forms/PickupInfoForm.vue";
import { DialogSize } from "@/constants/dialog";
import type { StopInfoDialogProps } from "@/types/props";

const showDialog = defineModel<boolean>({ default: false });

defineProps<StopInfoDialogProps>();

const emits = defineEmits<{
  (e: "save"): void;
}>();

const formRef = useTemplateRef<InstanceType<typeof PickupInfoForm> | null>("form");
const loading = ref<boolean>(false);

function save(): void {
  formRef.value?.save();
}

function onSave(): void {
  emits("save");
  showDialog.value = false;
}
</script>

<template>
  <omni-dialog
    v-model="showDialog"
    :disabled="loading"
    :loading="loading"
    :primary-action-label="readonly ? null : 'Save'"
    :size="DialogSize.xlarge"
    :title="title"
    @primary-action:click="save"
  >
    <pickup-info-form
      v-if="route && stop"
      ref="form"
      v-model:loading="loading"
      :preload="preload"
      :readonly="readonly"
      :route="route"
      :stop="stop"
      :trip-id="tripId"
      @save="onSave"
    />
  </omni-dialog>
</template>

<style lang="scss" scoped></style>
